// Subtle inline suggestion shown when the active discovery filters diverge from the
// contact's stored search profile. Explicit product directives: small dismissible strip
// (never a dialog), dismissal remembered per contact per session, must never block/nag.
import { useState } from "react";
import { Stack, Button, IconButton, Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";

type ProfileUpdateSuggestionProps = {
  contactFirstName: string;
  onAccept: () => Promise<void>;
  onDismiss: () => void;
};

export default function ProfileUpdateSuggestion({
  contactFirstName,
  onAccept,
  onDismiss
}: ProfileUpdateSuggestionProps): JSX.Element {
  const [saving, setSaving] = useState(false);

  const handleAccept = async (): Promise<void> => {
    setSaving(true);
    try {
      await onAccept();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        bgcolor: (theme) => alpha(theme.palette.info.main, 0.08)
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
        לעדכן את פרופיל החיפוש של {contactFirstName || "הלקוח"} לפי הסינון הזה?
      </Typography>
      <Button size="small" onClick={handleAccept} disabled={saving} sx={{ minWidth: 0 }}>
        עדכן
      </Button>
      <IconButton size="small" onClick={onDismiss} aria-label="סגירה">
        <Close sx={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  );
}
